/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const ShareLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="m13.12 17.02-4.2-2.29A3.99 3.99 0 0 1 2 12a4 4 0 0 1 6.92-2.73l4.2-2.3a4 4 0 1 1 .96 1.76l-4.2 2.3a4 4 0 0 1 0 1.95l4.2 2.29A3.99 3.99 0 0 1 21 18a4 4 0 1 1-7.88-.98M6 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4m11-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
  </Icon>
);
